import * as React from "react";

const InputComponent = ({ input, label, type, meta: {touched, error } }) => {

    return (
        <div className="row">
            <div className="medium-6 columns">
                <label className={touched && error && "has-error" }>{label}
                    { touched && error &&
                    <small className="error">&nbsp;{error}</small>
                    }
                    <input {...input} placeholder={label} type={type} />

                </label>
            </div>
        </div>
    );
};

export default InputComponent


// WEBPACK FOOTER //
// ./app/client/_widgets/form/InputComponent.tsx